export default function getBrowserData() {
  if (global.BROWSER) {
    const doc = document.documentElement;
    const docWidth = doc.clientWidth;
    const ua = navigator.userAgent;
    const devWidth = 767;
    let ddp;
    if ((docWidth > devWidth) && /android|ipad|ie|rv/i.test(ua)) {
      ddp = 'T';
    } else if (
      (docWidth < devWidth)
      && /android|blackberry|iphone|ipod|opera mini|iemobile/i.test(ua)
    ) {
      ddp = 'M';
    } else {
      ddp = 'D';
    }

    const np = navigator.plugins;
    const bpArr = [];
    if (np && np.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const element of np) {
        bpArr.push(element.name);
      }
    } else {
      bpArr.push('Unable to determine browser plugins');
    }

    return {
      browser_info: {
        screen_width: docWidth,
        screen_height: doc.clientHeight,
        browser_plugins: bpArr,
        device_type: ddp,
      },
    };
  }
  return {
    browser_info: {},
  };
}
